// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__8LdQA","disabled":"Button_disabled__+sKOI","primary":"Button_primary__EYsIF","outline":"Button_outline__gOQW4","rounded":"Button_rounded__1b5cF"};